<template>
  <div class="g-card" :class="`${custom_class}`">
    <div :class="['g-card-header', {'has-bottom': header_line}]">
      <slot name="title">
        <span class="title">{{title}}</span>
      </slot>
      <slot name="sub-title">
        <span class="sub-title">{{sub_title}}</span>
      </slot>

      <div class="card-ops card-header-right" v-if="has_operations">
        <slot name="operations">
          <a href="javascript:void(0)" class="text-op">文字操作示例</a>
          <el-button
            type="primary"
            size="small"
            plain>取消
          </el-button>
          <el-button
            type="primary"
            size="small">保存
          </el-button>
        </slot>
      </div>
    </div>
    <div class="g-card-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    // 主标题
    title: {
      type: String,
      default: '数据一览'
    },
    // 副标题
    sub_title: {
      type: String,
      default: ''
    },
    // 头底部是否有border-bottom
    header_line: {
      type: Boolean,
      default: false
    },
    // 是否有操作项
    has_operations: {
      type: Boolean,
      default: false
    },
    // 自定义类
    custom_class: {
      type: String,
      default: ''
    }
  }
}
</script>

<!-- element的el-button需要自定义，所以样式写成了全局样式，而不是scoped -->
<style>
.g-card {
  background: white;
}

.g-card-header {
  padding: 16px 22px;
  position: relative;
}

.g-card-header.has-bottom {
  border-bottom: 1px solid #ebeef5;
}

.g-card .title {
  color: #404040;
  font-size: 14px;
  font-weight: bold;
}

.g-card .sub-title {
  color: #9A9A9A;
  font-size: 12px;
  margin-left: 2px;
}

.g-card-content {
  padding: 0 20px 15px 20px;
}

.g-card .card-header-right {
  position: absolute;
  top: 0;
  line-height: 52px;
  right: 17px;
}
.g-card .text-op {
  margin-right: 12px;
  font-size: 12px;
}

.g-card-header .el-button {
  padding: 7px 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/BackdropCropper/el-card.vue